import React from "react";

interface CardProps {
  title?: string;
  children: React.ReactNode;
  flow?: boolean;
  shadow?: boolean;
}

const Card: React.FC<CardProps> = ({
  title,
  children,
  flow = false,
  shadow = false,
}) => {
  return (
    <div
      className={`${flow ? "w-full" : ""} mb-4 ml-4 bg-white rounded-lg ${shadow ? "shadow-md hover:shadow-lg transition-shadow duration-300" : "border"} overflow-hidden`}
    >
      <div className="p-6">
        {title && <h3 className="font-semibold mb-2 text-gray-800">{title}</h3>}
        {children}
      </div>
    </div>
  );
};

export default Card;
